import React from 'react';
import { CalendarClock } from 'lucide-react';

const MeetingPanelEmptyState = ({ selectedCircleIsRole }) => (
  <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm h-full flex flex-col items-center justify-center text-slate-500 text-sm gap-3">
    <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-slate-100 text-slate-400">
      <CalendarClock size={20} />
    </div>
    <div className="text-base font-semibold text-slate-700">Aucune réunion ouverte</div>
    <p className="text-xs text-slate-400 text-center max-w-sm">
      {selectedCircleIsRole
        ? 'Sélectionnez un cercle (pas un rôle) pour accéder à une réunion.'
        : "Ouvrez une réunion de gouvernance, tactique ou de pilotage depuis l'onglet Structure (« Créer une réunion »), ou rejoignez celle en cours."}
    </p>
  </div>
);

export default MeetingPanelEmptyState;
